{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "cap_",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "allowance",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "spender",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "approve",
      "inputs": [
        {
          "name": "spender",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "balanceOf",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "burn",
      "inputs": [
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "burnFrom",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "cap",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "decimals",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "mint",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "name",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "remainingMintableSupply",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "symbol",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "totalSupply",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transfer",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "transferFrom",
      "inputs": [
        {
          "name": "from",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "event",
      "name": "Approval",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "spender",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "Transfer",
      "inputs": [
        {
          "name": "from",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "to",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "ERC20ExceededCap",
      "inputs": [
        {
          "name": "increasedSupply",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "cap",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InsufficientAllowance",
      "inputs": [
        {
          "name": "spender",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "allowance",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "needed",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InsufficientBalance",
      "inputs": [
        {
          "name": "sender",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "balance",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "needed",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InvalidApprover",
      "inputs": [
        {
          "name": "approver",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InvalidCap",
      "inputs": [
        {
          "name": "cap",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InvalidReceiver",
      "inputs": [
        {
          "name": "receiver",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InvalidSender",
      "inputs": [
        {
          "name": "sender",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC20InvalidSpender",
      "inputs": [
        {
          "name": "spender",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    }
  ],
  "bytecode": "0x60a0604052346103c657610e076020813803918261001c816103ca565b9384928339810103126103c6575161003460406103ca565b90601082526f23b7bb32b93730b731b2902a37b5b2b760811b602083015261005c60406103ca565b600681526523aa37b5b2b760d11b602082015282519091906001600160401b0381116102cc57600354600181811c911680156103bc575b60208210146102ae57601f811161034e575b506020601f82116001146102eb57819293945f926102e0575b50508160011b915f199060031b1c1916176003555b81516001600160401b0381116102cc57600454600181811c911680156102c2575b60208210146102ae57601f8111610240575b50602092601f82116001146101df57928192935f926101d4575b50508160011b915f199060031b1c1916176004555b80156101c15760805233156101ae5760058054336001600160a01b03198216811790925560405191906001600160a01b03167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e05f80a3610a1790816103f082396080518181816104db01528181610559015261058e0152f35b631e4fbdf760e01b5f525f60045260245ffd5b63392e1e2760e01b5f525f60045260245ffd5b015190505f80610120565b601f1982169360045f52805f20915f5b8681106102285750836001959610610210575b505050811b01600455610135565b01515f1960f88460031b161c191690555f8080610202565b919260206001819286850151815501940192016101ef565b818111156101065760045f52601f820160051c7f8a35acfbc15ff81a39ae7d344fd709f28e8600b4aa8c65c6b64bfe7fe36bd19b602084106102a6575b81601f9101920160051c03905f5b828110610299575050610106565b5f8282015560010161028b565b5f915061027d565b634e487b7160e01b5f52602260045260245ffd5b90607f16906100f4565b634e487b7160e01b5f52604160045260245ffd5b015190505f806100be565b601f1982169060035f52805f20915f5b8181106103365750958360019596971061031e575b505050811b016003556100d3565b01515f1960f88460031b161c191690555f8080610310565b9192602060018192868b0151815501940192016102fb565b818111156100a55760035f52601f820160051c7fc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85b602084106103b4575b81601f9101920160051c03905f5b8281106103a75750506100a5565b5f82820155600101610399565b5f915061038b565b90607f1690610093565b5f80fd5b6040519190601f01601f191682016001600160401b038111838210176102cc5760405256fe6080806040526004361015610012575f80fd5b5f3560e01c90816306fdde03146106dc57508063095ea7b31461063457806318160ddd1461061757806323b872dd146105df578063313ce567146105c4578063349f0b901461057c578063355274ea1461054257806340c10f191461045657806342966c681461043957806354fd4d50146103ce57806370a0823114610397578063715018a61461034557806379cc6790146103135780638da5cb5b146102ed57806395d89b41146101e9578063a9059cbb146101b8578063dd62ed3e146101645763f2fde38b146100e2575f80fd5b34610160576020366003190112610160576001600160a01b036101036107be565b61010b61095f565b16801561014d576001600160a01b03600554828219821617600555167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e05f80a3005b631e4fbdf760e01b5f525f60045260245ffd5b5f80fd5b346101605760403660031901126101605761017d6107be565b6001600160a01b0361018d6107d4565b91165f5260016020526001600160a01b0360405f2091165f52602052602060405f2054604051908152f35b34610160576040366003190112610160576101de6101d46107be565b60243590336108b5565b602060405160018152f35b34610160575f366003190112610160576040515f6004548060011c906001811680156102e3575b6020831081146102cf578285529081156102ab575060011461024d575b6102498361023d818503826107ea565b60405191829182610794565b0390f35b91905060045f527f8a35acfbc15ff81a39ae7d344fd709f28e8600b4aa8c65c6b64bfe7fe36bd19b915f905b8082106102915750909150810160200161023d61022d565b919260018160209254838588010152019101909291610279565b60ff191660208086019190915291151560051b8401909101915061023d905061022d565b634e487b7160e01b5f52602260045260245ffd5b91607f1691610210565b34610160575f3660031901126101605760206001600160a01b0360055416604051908152f35b346101605760403660031901126101605761034361032f6107be565b6024359061033e82338361080c565b610986565b005b34610160575f3660031901126101605761035d61095f565b5f6001600160a01b0360055481198116600555167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e08280a3005b34610160576020366003190112610160576001600160a01b036103b86107be565b165f525f602052602060405f2054604051908152f35b34610160575f36600319011261016057604051604081019080821067ffffffffffffffff8311176104255761024991604052600c81526b23aa37b5b2b716991718971960a11b602082015260405191829182610794565b634e487b7160e01b5f52604160045260245ffd5b346101605760203660031901126101605761034360043533610986565b346101605760403660031901126101605761046f6107be565b6001600160a01b036024359161048361095f565b1690811561052f576002549080820180921161051b5760207fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef915f9360025584845283825260408420818154019055604051908152a37f000000000000000000000000000000000000000000000000000000000000000060025481811161050657005b63279e7e1560e21b5f5260045260245260445ffd5b634e487b7160e01b5f52601160045260245ffd5b63ec442f0560e01b5f525f60045260245ffd5b34610160575f3660031901126101605760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b34610160575f366003190112610160577f0000000000000000000000000000000000000000000000000000000000000000600254810390811161051b57602090604051908152f35b34610160575f36600319011261016057602060405160128152f35b34610160576060366003190112610160576101de6105fb6107be565b6106036107d4565b6044359161061283338361080c565b6108b5565b34610160575f366003190112610160576020600254604051908152f35b346101605760403660031901126101605761064d6107be565b6024359033156106c9576001600160a01b03169081156106b657335f52600160205260405f20825f526020528060405f20556040519081527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560203392a3602060405160018152f35b634a1406b160e11b5f525f60045260245ffd5b63e602df0560e01b5f525f60045260245ffd5b34610160575f366003190112610160575f6003548060011c9060018116801561078a575b6020831081146102cf578285529081156102ab575060011461072c576102498361023d818503826107ea565b91905060035f527fc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85b915f905b8082106107705750909150810160200161023d61022d565b919260018160209254838588010152019101909291610758565b91607f1691610700565b602060409281835280519182918282860152018484015e5f828201840152601f01601f1916010190565b600435906001600160a01b038216820361016057565b602435906001600160a01b038216820361016057565b90601f8019910116810190811067ffffffffffffffff82111761042557604052565b6001600160a01b03909291921691825f52600160205260405f206001600160a01b0382165f5260205260405f2054925f19840361084a575b50505050565b8284106108915780156106c9576001600160a01b038216156106b6575f5260016020526001600160a01b0360405f2091165f5260205260405f20910390555f808080610844565b506001600160a01b038391637dc7a0d960e11b5f521660045260245260445260645ffd5b6001600160a01b031690811561094c576001600160a01b031691821561052f57815f525f60205260405f205481811061093357817fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef92602092855f525f84520360405f2055845f525f825260405f20818154019055604051908152a3565b8263391434e360e21b5f5260045260245260445260645ffd5b634b637e8f60e11b5f525f60045260245ffd5b6001600160a01b0360055416330361097357565b63118cdaa760e01b5f523360045260245ffd5b9091906001600160a01b0316801561094c57805f525f60205260405f20548381106109f0576020845f94957fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef938587528684520360408620558060025403600255604051908152a3565b915063391434e360e21b5f5260045260245260445260645ffdfea164736f6c6343000821000a"
}
